export const html = `<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <link rel="preconnect" href="https://fonts.gstatic.com" />
  <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap"
    rel="stylesheet" />
  <title>template_name</title>
</head>
<style>
  body {
    max-width: 1000px;
    margin: 0 auto;
    font-family: Roboto;
  }

  .header {
    font-style: normal;
    text-align: center;
    font-weight: 600;
  }

  .divider {
    border: 1px solid #000000;
  }

  .signature {
    font-weight: 600;
    display: flex;
    font-size: 16px;
    align-items: center;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .signature_view {
    margin-left: 15px;
  }

  .signature_view div {
    font-size: 14px;
    font-weight: 500;
    text-align: center;
  }

  .spacer {
    flex: 1;
  }

  .underline {
    width: 200px;
    margin-top: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #000000;
  }

  .date_underline {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
    border-bottom: 5px solid #000000;
  }

  @media print {
    @page {
      margin: 0;
      size: portrait;
    }

    body {
      margin: 1.6cm;
    }
  }

  .watermark {
    transform: rotate(-45deg);
    position: fixed;
    top: 400px;
    opacity: 0.4;
    left: 0;
    right: 0;
  }

  .watermark h1,
  .watermark h4 {
    text-align: center;
    margin: 0px;

  }
</style>

<body>
  <div class="watermark" id="watermark">
    <h1>COMPLETED & PAID</h1>
    <h4>contract_date</h4>
  </div>

  <h4 class="header">
    EL CHEAPO 24 HOUR MOBILE LOCKSMITH & ROAD SERVICES<br />
    3026 Midway drive, San Diego CA 92110<br />
    Locksmith license LCO#7316
  </h4>
  <div class="divider"></div>
  <h3 class="header">Terms & Conditions Contract - template_name
    <br />
    Job #{job_number}
  </h3>
  <div contenteditable="plaintext-only" oncut="return false" onpaste="return false"
    onkeydown="if(event.metaKey) return true; return false;">contract_message</div>
  <div class="signature">
    <h4>
      Signature
    </h4>
    <div class="signature_view">
      <div>customer_name</div>
      <div class="underline"></div>
      <div>Electronically Signed.</div>
    </div>
    <div class="spacer"></div>
    <div class="date">
      <div>
        Date of Agreement :
        <span style="font-weight: normal">
          contract_date
        </span>
      </div>
      <div class="date_underline"></div>
      <span style="font-weight: normal">
        RECORDING TIMESTAMP contract_time
      </span>
    </div>
  </div>
</body>

</html>
`;
